import { injectable } from "tsyringe";
import { IEnvironment } from "./IEnvironment";

@injectable()
export class Environment implements IEnvironment {
    get isProd() { return import.meta.env.PROD; }
    get backendUrl() { return import.meta.env.VITE_BACKEND_URL; }
}